var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 180.5 61.4",
    style: {
      enableBackground: "new 0 0 180.5 61.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFE300;}\n\t.st1{fill:#00011C;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.8,0H0v11.5h9.8c10.6,0,19.2,8.6,19.2,19.2c0,10.6-8.6,19.2-19.2,19.2H0v11.5h9.8c16.9,0,31.1-12.4,31.1-30.7 C40.8,12.2,26.7,0,9.8,0 M34.6,49.9v11.5h11.5V49.9H34.6z M149.8,30.7l22.6-22.6V0h-8.5l-26.4,26.4V0H34.7v11.5h21.6v49.9h12.1V11.5 h21.7c-4,5.1-6.4,11.6-6.4,19.2c0,18.3,14.1,30.7,31.1,30.7h22.6V35l26.4,26.4h16.7L149.8,30.7z M125.3,49.9h-10.5 c-8.6,0-16-5.7-18.4-13.6h17V25.1h-17c2.4-7.9,9.7-13.6,18.4-13.6h10.5V49.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.8,11.5H0v38.4h9.8c10.6,0,19.2-8.6,19.2-19.2C28.9,20.1,20.3,11.5,9.8,11.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0d0d319fc0b47c7ad1842be208df77ef.svg";
export { ForwardRef as ReactComponent };